import ApplicationController from './application_controller'

export default class SpreadsheetController extends ApplicationController {

	static targets = ['cell']

	cellTargetConnected(cell) {
		this.addKeydownListener(cell)
		this.updateAddRemoveCellButtons(cell)
	}

	addKeydownListener(cell) {
		cell.addEventListener('contextmenu', function(event) {
			event.preventDefault()
			SpreadsheetController.setInitialCellValue(this)
		})

		cell.addEventListener('keydown', function(event) {
			let currentCell = null
			if (this.tagName === 'TD') {
				currentCell = this
			} else {
				currentCell = this.closest('td')
			}

			const currentRow = currentCell.closest('tr')
			const columnIndex = Array.from(currentRow.children).indexOf(currentCell)
			const editableCellsInRow = Array.from(currentRow.querySelectorAll('td[spreadsheet-editable]'))
			const editableCellIndex = editableCellsInRow.indexOf(currentCell)

			if (event.shiftKey && [37,38,39,40].some(arrowKey => arrowKey === event.keyCode)) {
				SpreadsheetController.setInitialCellValue(this)
			}

			if (event.keyCode == 32) {
				event.preventDefault()
				SpreadsheetController.setInitialCellValue(this)
			}

			if ((event.key === 'Enter' && event.shiftKey) || event.key === 'ArrowUp' ) {
				event.preventDefault()
				const previousRow = currentRow.previousElementSibling

				if (previousRow) {
					const previousCell = previousRow.children[columnIndex]
					if (previousCell) { SpreadsheetController.focusCell(previousCell) }
				}
			} else if (event.key === 'Enter' || event.key === 'ArrowDown') {
				event.preventDefault()

				const nextRow = currentRow.nextElementSibling
				if (nextRow) {
					const nextCell = nextRow.children[columnIndex]
					if (nextCell) { SpreadsheetController.focusCell(nextCell) }
				}
			} else if (event.key === 'ArrowRight' || (event.key === 'Tab' && !event.shiftKey)) {
				event.preventDefault()
				if (editableCellIndex === (editableCellsInRow.length - 1)) {
					const nextRow = currentRow.nextElementSibling
					const nextCell = nextRow.children[1]
					if (nextCell) { SpreadsheetController.focusCell(nextCell) }
				} else {
					const nextCell = currentCell.nextElementSibling
					if (nextCell) { SpreadsheetController.focusCell(nextCell) }
				}
			} else if (event.key === 'ArrowLeft' || (event.key === 'Tab' && event.shiftKey)) {
				event.preventDefault()
				if (editableCellIndex === 0) {
					const previousRow = currentRow.previousElementSibling
					if (!previousRow) { return }
					const previousRowEditableCells = Array.from(previousRow.querySelectorAll('td[spreadsheet-editable]'))
					const previousCell = previousRowEditableCells[previousRowEditableCells.length - 1 ]
					if (previousCell) { SpreadsheetController.focusCell(previousCell) }
				} else {
					const previousCell = currentCell.previousElementSibling
					if (previousCell) { SpreadsheetController.focusCell(previousCell) }
				}
			}
		})

		cell.addEventListener('focus', function(_event) {
			// This selects all text on cell focus.
			const range = document.createRange()
			range.selectNodeContents(this)
			const selection = window.getSelection()
			selection.removeAllRanges()
			selection.addRange(range)

			this.parentElement.querySelectorAll('td').forEach(focusCell => {
				focusCell.classList.add('bg-primary-xlight')
			})
		})

		cell.addEventListener('focusout', function() {
			this.parentElement.querySelectorAll('td').forEach(focusCell => {
				focusCell.classList.remove('bg-primary-xlight')
			})
		})
	}

	setInitialValue(event) {
		const currentCell = event.currentTarget.closest('td')
		const currentContentEditable = currentCell.querySelector('[contenteditable=true]')

		SpreadsheetController.setInitialCellValue(currentContentEditable)

		currentCell.querySelector('button.delete-value').classList.remove('d-none')
		currentCell.querySelector('button.set-initial-value').classList.add('d-none')
	}

	deleteValue(event) {
		const currentCell = event.currentTarget.closest('td')
		const currentContentEditable = currentCell.querySelector('[contenteditable=true]')

		currentContentEditable.innerHTML = ''
		SpreadsheetController.sendInputEvent(currentContentEditable)

		currentCell.querySelector('button.delete-value').classList.add('d-none')
		currentCell.querySelector('button.set-initial-value').classList.remove('d-none')
	}

	updateAddRemoveButtons(event) {
		let cell = null
		if (event.currentTarget.tagName === 'TD') {
			cell = event.currentTarget
		} else { 
			cell = event.currentTarget.closest('td')
		}

		this.updateAddRemoveCellButtons(cell)
	}

	updateAddRemoveCellButtons(cell) {
		const cellInput = cell.contentEditable ? cell : cell.querySelector('[contenteditable]')
		const currentCellValue = cellInput.innerText.trim()
		let setButton, deleteButton = null
		if (currentCellValue === '') {
			if (setButton = cell.querySelector('button.set-initial-value')) { setButton.classList.remove('d-none') }
			if (deleteButton = cell.querySelector('button.delete-value'))   { deleteButton.classList.add('d-none') }
		} else {
			if (setButton = cell.querySelector('button.set-initial-value')) { setButton.classList.add('d-none') }
			if (deleteButton = cell.querySelector('button.delete-value'))   { deleteButton.classList.remove('d-none') }
		}
	}

	static setInitialCellValue(cell) {
		if ((cell.innerHTML === "" || cell.innerHTML === "<br>") && cell.dataset.contenteditableInitialValue) {
			cell.innerHTML = cell.dataset.contenteditableInitialValue
			SpreadsheetController.sendInputEvent(cell)
		}
	}

	static sendInputEvent(element) {
		const event = new Event('input', { bubbles: true })
		element.dispatchEvent(event)
	}

	static focusCell(cell) {
		if (cell.contentEditable === 'true') {
			cell.focus()
		} else { 
			cell.querySelector('[contenteditable=true]').focus()
		}
	}
}
